<ng-container [ngSwitch]="phxTagPlacement">
  <!-- tag-only -->
  <ng-container *ngSwitchCase="'tag-only'">
    <ng-container *ngTemplateOutlet="tagTpl"></ng-container>
  </ng-container>

  <!-- as-primary: tag stands in for the primary line, secondary below -->
  <ng-container *ngSwitchCase="'as-primary'">
    <ng-container *ngTemplateOutlet="tagTpl"></ng-container>
    <ng-container *ngTemplateOutlet="secondaryTpl"></ng-container>
  </ng-container>

  <!-- above-primary -->
  <ng-container *ngSwitchCase="'above-primary'">
    <ng-container *ngTemplateOutlet="tagTpl"></ng-container>
    <ng-container *ngTemplateOutlet="primaryTpl"></ng-container>
    <ng-container *ngTemplateOutlet="secondaryTpl"></ng-container>
  </ng-container>

  <!-- below-primary -->
  <ng-container *ngSwitchCase="'below-primary'">
    <ng-container *ngTemplateOutlet="primaryTpl"></ng-container>
    <ng-container *ngTemplateOutlet="tagTpl"></ng-container>
  </ng-container>

  <!-- right-of-secondary -->
  <ng-container *ngSwitchCase="'right-of-secondary'">
    <ng-container *ngTemplateOutlet="primaryTpl"></ng-container>
    <span class="phx-table-cell-tag-inline">
      <ng-container *ngTemplateOutlet="secondaryTpl"></ng-container>
      <ng-container *ngTemplateOutlet="tagTpl"></ng-container>
    </span>
  </ng-container>

  <!-- right-of-primary (default) -->
  <ng-container *ngSwitchDefault>
    <span class="phx-table-cell-tag-inline">
      <ng-container *ngTemplateOutlet="primaryTpl"></ng-container>
      <ng-container *ngTemplateOutlet="tagTpl"></ng-container>
    </span>
    <ng-container *ngTemplateOutlet="secondaryTpl"></ng-container>
  </ng-container>
</ng-container>

<!-- ── Reusable pieces ─────────────────────────── -->

<ng-template #primaryTpl>
  <ng-container *ngIf="primary as p">
    <a
      *ngIf="phxPrimaryLink; else primaryPlain"
      class="phx-table-cell-tag-link"
      [routerLink]="phxPrimaryLink"
      (click)="$event.stopPropagation()"
    >
      <ng-container
        *ngTemplateOutlet="lineTpl; context: { seg: p, size: 'medium', defaultIntent: 'active' }"
      ></ng-container>
    </a>
    <ng-template #primaryPlain>
      <ng-container
        *ngTemplateOutlet="lineTpl; context: { seg: p, size: 'medium', defaultIntent: 'standard' }"
      ></ng-container>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #secondaryTpl>
  <ng-container *ngTemplateOutlet="subLinesTpl; context: { items: secondaryValue }"></ng-container>
</ng-template>

<!-- Secondary sub-line -->
<ng-template #subLinesTpl let-items="items">
  <span *ngIf="items" class="phx-table-cell-tag-sub-line">
    <ng-container *ngFor="let item of items; let isLast = last; trackBy: trackBySegment">
      <ng-container
        *ngTemplateOutlet="lineTpl; context: { seg: item, size: 'small', defaultIntent: 'subdued' }"
      ></ng-container>
      <i *ngIf="!isLast && items.length > 1" phx-icon [phxIcon]="Bullet16Icon"></i>
    </ng-container>
  </span>
</ng-template>

<!-- Shared line renderer. -->
<ng-template #lineTpl let-seg="seg" let-size="size" let-defaultIntent="defaultIntent">
  <phx-text
    *ngIf="seg.truncate || seg.tooltipContent"
    class="phx-table-cell-tag-text"
    [phxDecoration]="seg.decoration"
    [phxEmphasis]="seg.emphasis"
    [phxItalic]="seg.italic"
    [phxSize]="size"
    [phxTextIntent]="seg.intent || defaultIntent"
    [phxTruncate]="seg.truncate"
    phx-tooltip
    phx-tooltip-on-truncate
    [phxContent]="seg.tooltipContent || seg.value"
    [phxTruncationTooltipDisabled]="seg.tooltipContent"
    phxTrigger="hover"
    >{{ seg.value }}</phx-text
  >
  <phx-text
    *ngIf="!seg.truncate && !seg.tooltipContent"
    class="phx-table-cell-tag-text"
    [phxDecoration]="seg.decoration"
    [phxEmphasis]="seg.emphasis"
    [phxItalic]="seg.italic"
    [phxSize]="size"
    [phxTextIntent]="seg.intent || defaultIntent"
    [phxTruncate]="seg.truncate"
    >{{ seg.value }}</phx-text
  >
</ng-template>

<ng-template #tagTpl>
  <phx-tag
    *ngIf="phxTagTooltip"
    [phxTagType]="phxTagType"
    [phxContrast]="phxTagContrast"
    [phxSize]="resolvedTagSize"
    phx-tooltip
    [phxContent]="phxTagTooltip"
    [phxTrigger]="'hover'"
    >{{ phxTagLabel }}</phx-tag
  >
  <phx-tag
    *ngIf="!phxTagTooltip"
    [phxTagType]="phxTagType"
    [phxContrast]="phxTagContrast"
    [phxSize]="resolvedTagSize"
    >{{ phxTagLabel }}</phx-tag
  >
</ng-template>
